import store from '@/store';
import { logGuard } from '@/router/helpers';
export const beforeResolveGuard = async (to, from, next) => {
    logGuard('[BEFORE_RESOLVE_GUARD] to', to);
    await store.dispatch('setIsLoading', false);
    logGuard('[BEFORE_RESOLVE_GUARD] starting next()');
    next();
};
